export const convierteFechaLargaEnFechaCorta = (fechaOriginal) => {
  const fecha = new Date(fechaOriginal);
  const dia = fecha.getDate();
  const mes = fecha.getMonth() + 1; // Nota: los meses comienzan desde 0
  const anio = fecha.getFullYear();

  // Formato deseado: DD-MM-YYYY
  const fechaFormateada = `${dia < 10 ? "0" : ""}${dia}-${
    mes < 10 ? "0" : ""
  }${mes}-${anio}`;

  // console.log(fechaFormateada); // Salida: "13-12-2023"
  return fechaFormateada;
};

export const convierteFechaLargaEnFechaCortaYGringa = (fechaOriginal) => {
  const fecha = new Date(fechaOriginal);
  const dia = fecha.getDate();
  const mes = fecha.getMonth() + 1; // Nota: los meses comienzan desde 0
  const anio = fecha.getFullYear();

  // Formato deseado: DD-MM-YYYY
  const fechaFormateada = `${anio}-${mes < 10 ? "0" : ""}${mes}-${
    dia < 10 ? "0" : ""
  }${dia}`;

  // console.log(fechaFormateada); // Salida: "13-12-2023"
  return fechaFormateada;
};

export const quitaSegundosATime = (horaOriginal) => {
  // console.log("horaSinSegundos", horaSinSegundos); // Salida: "09:00"
  const horaSinSegundos = horaOriginal.slice(0, -3);

  // console.log(horaSinSegundos); // Salida: "09:00"
  return horaSinSegundos;
};

export const convierteFechaAFechaFormateada = (fechaInput) => {
  if (fechaInput) {
    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ];
    const diasSemana = [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ];

    // Convertir a objeto Date
    const fecha = new Date(fechaInput);

    // Obtener día de la semana, mes y número de día
    const diaSemana = diasSemana[fecha.getDay()];
    const diaMes = fecha.getDate();
    const mes = meses[fecha.getMonth()];
    const ano = fecha.getFullYear();

    // Formatear la fecha en el formato deseado
    const fechaFormateada = `${diaSemana} ${diaMes} de ${mes} ${ano}`;
    console.log(fechaFormateada);
    return fechaFormateada;
  } else return "";
};

export const convierteFechaYHoraAFechaFormateada = (fechaInput) => {
  const meses = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  const diasSemana = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];

  // Convertir a objeto Date
  const fecha = new Date(fechaInput);

  // Obtener día de la semana, mes y número de día
  const diaSemana = diasSemana[fecha.getDay()];
  const diaMes = fecha.getDate();
  const mes = meses[fecha.getMonth()];
  const ano = fecha.getFullYear();

  const hora = fecha.getHours().toString().padStart(2, "0");
  const minutos = fecha.getMinutes().toString().padStart(2, "0");

  // Formatear la fecha en el formato deseado
  const fechaFormateada = `${diaSemana} ${diaMes} de ${mes} ${ano}, ${hora}:${minutos}`;
  console.log(fechaFormateada);
  return fechaFormateada;
};

export const convierteFechaUtcATimeSinSegundos = (fechaInput) => {
  const horas = ("0" + fechaInput.getUTCHours()).slice(-2); // Obtener las horas
  const minutos = ("0" + fechaInput.getUTCMinutes()).slice(-2); // Obtener los minutos
  const segundos = ("0" + fechaInput.getUTCSeconds()).slice(-2); // Obtener los minutos
  fechaInput = `${horas}:${minutos}:${segundos}`;
  return fechaInput;
};

export function esNumerico(valor) {
  return !isNaN(valor);
}
export function esCorreoValido(correo) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(correo);
}

export function formatearFecha(fecha) {
  // Dividir la fecha en día, mes y año
  const partesFecha = fecha.split("-");
  const dia = partesFecha[0];
  const mes = partesFecha[1];
  const anio = partesFecha[2];

  // Agregar ceros a la izquierda si el día o mes tienen un solo dígito
  const diaFormateado = dia.padStart(2, "0");
  const mesFormateado = mes.padStart(2, "0");

  // Devolver la fecha formateada en el formato deseado ('yyyy-mm-dd')
  return `${anio}-${mesFormateado}-${diaFormateado}`;
}
